import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import {
  addHospitalSubscription,
  mapSubscriptionPlan,
} from "../services/SubscriptionServices";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SubscriptionCard from "./SubscriptionCard";
import { getSubscriptionPlans } from "../services/SubscriptionServices";
import RazorpayPayment from "../payment/RazorpayPayment";
import {
  addHospitalDetails,
  addHospitalUser,
} from "../../components/services/HospitalServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import * as Yup from "yup";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { logOut } from "../config/user";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Addhospital.scss";
import UploadImage from "./UploadImage";
import CrossIcon from "../assets/crossIcon.svg";
import MapBoundaryDrawer from "./MapBoundaryDrawer";
import { ErrorOutlineSharp } from "@mui/icons-material";
import { toast } from "react-toastify";

const hospitalNameRegex =
  /^[A-Za-z0-9\s&/]+(?:[A-Za-z0-9\s&/]*[A-Za-z]+[A-Za-z0-9\s&/]*|[A-Za-z0-9\s&/]*\d+[A-Za-z0-9\s&/]*)(?<![@#%^*()])$/;
const hospitalDetailsValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .matches(/[a-zA-Z]/, "Email must contain at least one letter")
    .matches(/\.com$/, "Email must end with '.com'")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
  fullName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s]+$/, "Full Name must contain only letters and spaces")
    .min(3, "Full Name must be at least 3 characters")
    .required("Full Name is required"),
  position: Yup.string().required("Please choose a designation"),
  otherPosition: Yup.string().when("position", {
    is: "Other",
    then: (schema) =>
      schema
        .matches(
          /^[A-Za-z\s]+$/,
          "Designation must contain only letters and spaces",
        )
        .required("Please specify the designation"),
    otherwise: (schema) => schema.notRequired(),
  }),
  phone: Yup.string()
    .matches(/^[0-9]+$/, "Phone number must contain only digits")
    .length(10, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),
  name: Yup.string()
    .matches(
      hospitalNameRegex,
      "Hospital name must contain a mix of letters, numbers, spaces, and allowed special characters (&, /), but no invalid characters (@, #, %, ^, *, (, ))",
    )
    .min(3, "Full Name must be at least 3 characters")
    .required("Required"),
  country: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  pincode: Yup.string().required("Required"),
  businessDocumentType: Yup.string().required("Required"),
  businessDocumentUrl: Yup.string().required("Required"),
  businessDocumentNumber: Yup.string().required("Required"),
  pincode: Yup.string()
    .length(6, "Pincode must be exactly 6 digits")
    .required("Pincode is required")
    .matches(/^[0-9]+$/, "Pincode must contain only digits"),

  businessDocumentNumber: Yup.string()
    .matches(
      /^(?![\d]+$)(?![^\w\d]+$)[\w\d]{8,20}$/,
      "Business Document Number must contain a mix of letters and numbers, no spaces, and between 8 and 20 characters",
    )
    .required("Business Document Number is required"),
  tmsVersion: Yup.string().required("TMS Version Required"),
});
const hospitalCredentialsSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .matches(/[a-zA-Z]/, "Email must contain at least one letter")
    .matches(/\.com$/, "Email must end with '.com'")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
  fullName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s]+$/, "Full Name must contain only letters and spaces")
    .min(3, "Full Name must be at least 3 characters")
    .required("Full Name is required"),
  position: Yup.string().required("Please choose a designation"),
  otherPosition: Yup.string().when("position", {
    is: "Other",
    then: (schema) =>
      schema
        .matches(
          /^[A-Za-z\s]+$/,
          "Designation must contain only letters and spaces",
        )
        .required("Please specify the designation"),
    otherwise: (schema) => schema.notRequired(),
  }),
  phone: Yup.string()
    .matches(/^[0-9]+$/, "Phone number must contain only digits")
    .length(10, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),
});

const subscriptionDetailsValidationSchema = Yup.object({});

const AddHospital = () => {
  const [subscriptionPlans, setSubscriptionPlans] = useState();
  const [selectedDuration, setSelectedDuration] = useState("quarterly");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [filteredPlan, setFilteredPlan] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [documentType, setDocumentType] = useState(null);
  const [hospitalId, setHospitalId] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedHospital, setSelectedHospital] = useState({});
  const [subscriptionIds, setSubscriptionIds] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const [amountToPay, setAmountToPay] = useState(null);
  const [polygon, setPolygon] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [payment, setPayment] = useState({
    subtotal: "",
    discount: "",
    total: "",
  });

  const navigate = useNavigate();

  const documentTypeOptions = [
    { value: "PAN", label: "PAN" },
    { value: "HRC", label: "HRC" },
  ];

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  };

  const SubscriptionPlans = async () => {
    try {
      const res = await getSubscriptionPlans();
      setSubscriptionPlans(res.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // const handleSubscriptionMapping = async () => {
  //   setIsLoading(true);
  //   const data = {
  //     subscriptionIds: subscriptionIds,
  //     payment: payment,
  //     global: {
  //       couponCode: "",
  //       hospitalId: hospitalId,
  //     },
  //   };
  //   try {
  //     const response = await mapSubscriptionPlan(data);
  //     setOrderId(response.data.id);
  //     setAmountToPay(response.data.amount / 100);
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //     handleApiErrorResponses(error);
  //   }
  // };
  const handlePaymentDetails = (name, value) => {
    setPaymentDetails((prev) => ({ ...prev, [name]: value }));
  };
  const getTodayDate = () => {
    const today = new Date();

    // Create date at UTC midnight
    const utcDate = new Date(
      Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()),
    );

    return utcDate.toISOString();
  };

  const handleSubscriptionMapping = async () => {
    if (!selectedPlan) {
      alert("Please select a hospital and plan first!");
      return;
    }

    const payload = {
      hospitalId: hospitalId,
      startDate: getTodayDate(),
      // startDate: new Date().toISOString(),
      status: "PAID",
      subscriptionId: selectedPlan.id,
      transactionId: "",
      paymentType: "",
      orderId: "",
    };

    setIsLoading(true);
    try {
      const response = await addHospitalSubscription(payload);
      console.log("✅ Subscription Added:", response?.data);
      toast.success(response?.data?.message);
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleAddHospitalUser = async (values, hospitalId) => {
    values = { ...values, hospitalId: hospitalId };
    try {
      const res = addHospitalUser(values);
      toast.success("Hospital Added Successfully");
      navigate("/dashboard/hospitallist");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSubmit = async (values) => {
    if (!polygon.length) {
      toast.error("Please select cordinates from map.");
      return;
    }
    const data = {
      ...values,
      locationDetails: {
        polygon: polygon,
      },
    };
    try {
      setHospitalName(values.name);
      const res = await addHospitalDetails(data);
      setHospitalId(res.data.hospitalId);

      toast.success("Hospital details added sucessfully");
      await handleAddHospitalUser(values, res.data.hospitalId);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px solid #D9D9D9",
      borderRadius: "8px",
      paddingLeft: "1rem",
      paddingRight: "1rem",
      minHeight: "40px",
      boxShadow: state.isFocused ? "0 0 0 2px #16a34a88" : undefined,
      borderColor: state.isFocused ? "#16a34a" : "#D9D9D9",
      "&:hover": {
        borderColor: "#16a34a",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#A3A3A3",
      fontSize: "1rem",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#000",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#16a34a" : "#666",
      "&:hover": {
        color: "#16a34a",
      },
    }),
    indicatorSeparator: () => ({}),
  };

  useEffect(() => {
    SubscriptionPlans();
    setCountryList(Country.getAllCountries());
  }, []);

  useEffect(() => {
    const filteredData = subscriptionPlans?.filter(
      (plan) => plan.planType.toLowerCase() === selectedDuration,
    );
    setFilteredPlan(filteredData);
  }, [subscriptionPlans, selectedDuration]);

  useEffect(() => {
    setStateList(State?.getStatesOfCountry(selectedCountry?.isoCode));
  }, [selectedCountry]);

  useEffect(() => {
    setCityList(
      City.getCitiesOfState(selectedState?.countryCode, selectedState?.isoCode),
    );
  }, [selectedState]);
  useEffect(() => {
    if (selectedPlan) {
      setSubscriptionIds([selectedPlan.id]);
      setPayment({
        ...payment,
        subtotal: selectedPlan.totalWithGst,
        total: selectedPlan.totalWithGst,
      });
    }
  }, [selectedPlan]);

  return (
    <div
      style={{
        fontFamily: "Inter",
        padding: 32,
        marginTop: 93,
        width: "100%",
      }}
    >
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Profile &nbsp; &nbsp;/ &nbsp; &nbsp; Add Hospital
      </span>
      <div className="heading">Add Hospital</div>
      <hr
        style={{
          color: "#E7E7E7",
        }}
      />
      <div>
        <Accordion
          className="accordionbox rounded-[16px] w-full"
          sx={{ borderRadius: "16px" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ padding: "0 16px" }}
          >
            <p className="font-bold text-[16px] m-0">Hospital Details</p>
          </AccordionSummary>

          <AccordionDetails>
            <div className="w-full overflow-x-auto">
              <div className="flex flex-col gap-4 min-w-[320px] w-full">
                <Formik
                  initialValues={{
                    name: "",
                    country: "",
                    state: "",
                    city: "",
                    pincode: "",
                    businessDocumentType: "",
                    businessDocumentUrl: "",
                    businessDocumentNumber: "",
                    logoUrl: "",
                    tmsVersion: "",
                    roleName: "hospital",
                    phone: "",
                    email: "",
                    hospitalId: hospitalId,
                    password: "",
                    tmsVersion: "",
                    fullName: "",
                    position: "",
                    otherPosition: "",
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    handleSubmit(values);
                    setSubmitting(false);
                  }}
                  validateOnChange={true}
                  validateOnBlur={false}
                  validationSchema={hospitalDetailsValidationSchema}
                >
                  {({
                    isSubmitting,
                    values,
                    setFieldValue,
                    touched,
                    errors,
                  }) => (
                    <Form className="w-full">
                      <div className="flex flex-wrap gap-4">
                        {/* <div className="flex justify-center w-full mt-8">
                          <button
                            type="submit"
                            style={{
                              width: "125px",
                              height: "34px",
                              borderRadius: "32px",
                              padding: "8px 16px",
                              gap: "8px",
                              backgroundColor: "rgba(1, 124, 87, 1)",
                              color: "white",
                              border: "none",
                            }}
                          >
                            SAVE DETAILS
                          </button>
                        </div> */}
                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Hospital Name
                          </label>
                          <Field
                            type="text"
                            name="name"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Hospital Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Country
                          </label>
                          <Select
                            name="country"
                            styles={selectStyles}
                            options={Country.getAllCountries()}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.name}
                            value={selectedCountry}
                            onChange={(item) => {
                              setSelectedCountry(item);
                              setFieldValue("country", item.name);
                            }}
                            placeholder="Select Country"
                            classNamePrefix="react-select"
                          />
                          <ErrorMessage
                            name="country"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            State
                          </label>
                          <Select
                            name="state"
                            styles={selectStyles}
                            options={stateList}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.name}
                            value={selectedState}
                            onChange={(item) => {
                              setSelectedState(item);
                              setFieldValue("state", item.name);
                            }}
                            placeholder="Select State"
                            classNamePrefix="react-select"
                          />
                          <ErrorMessage
                            name="state"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            City
                          </label>
                          <Select
                            name="city"
                            styles={selectStyles}
                            options={cityList}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.name}
                            value={selectedCity}
                            onChange={(item) => {
                              setSelectedCity(item);
                              setFieldValue("city", item.name);
                            }}
                            placeholder="Select City"
                            classNamePrefix="react-select"
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Pincode
                          </label>
                          <Field
                            type="text"
                            name="pincode"
                            maxLength="6"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter PIN"
                          />
                          <ErrorMessage
                            name="pincode"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Business Document Type
                          </label>
                          <Select
                            name="businessDocumentType"
                            styles={selectStyles}
                            options={documentTypeOptions}
                            defaultValue={documentTypeOptions.find(
                              (dt) => dt.value === documentType,
                            )}
                            onChange={(item) => {
                              setDocumentType(item.value);
                              setFieldValue("businessDocumentType", item.value);
                            }}
                            placeholder="Select Business Document Type"
                            classNamePrefix="react-select"
                          />
                          <ErrorMessage
                            name="businessDocumentType"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Upload Business Document
                          </label>
                          <UploadImage
                            setFieldValue={setFieldValue}
                            fieldName="businessDocumentUrl"
                          />

                          {values.businessDocumentUrl &&
                            (values.businessDocumentUrl
                              .split("?")[0]
                              .toLowerCase()
                              .endsWith(".pdf") ? (
                              <a
                                href={values?.businessDocumentUrl}
                                target="_blank"
                              >
                                {" "}
                                View Document
                              </a>
                            ) : (
                              <img
                                src={values.businessDocumentUrl}
                                alt="logo"
                                className="mt-2 w-24 h-auto rounded"
                              />
                            ))}
                          <ErrorMessage
                            name="businessDocumentUrl"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Business Document Number
                          </label>
                          <Field
                            type="text"
                            name="businessDocumentNumber"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Document Number"
                          />
                          <ErrorMessage
                            name="businessDocumentNumber"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Upload Hospital Logo
                          </label>
                          <UploadImage
                            setFieldValue={setFieldValue}
                            fieldName="logoUrl"
                          />
                          {values.logoUrl &&
                            (values.logoUrl
                              .split("?")[0]
                              .toLowerCase()
                              .endsWith(".pdf") ? (
                              <a href={values?.logoUrl} target="_blank">
                                {" "}
                                View Logo
                              </a>
                            ) : (
                              <img
                                src={values.logoUrl}
                                alt="logo"
                                className="mt-2 w-24 h-auto rounded"
                              />
                            ))}
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            TMS Version
                          </label>
                          <Select
                            name="tmsVersion"
                            styles={selectStyles}
                            options={[
                              { value: "1.0", label: "1.0" },
                              { value: "2.0", label: "2.0" },
                            ]}
                            onChange={(item) =>
                              setFieldValue("tmsVersion", item.value)
                            }
                            placeholder="Select TMS Version"
                            classNamePrefix="react-select"
                          />
                          <ErrorMessage
                            name="tmsVersion"
                            component="div"
                            className="text-red-600 text-sm mt-1"
                          />
                        </div>

                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Email
                          </label>
                          <Field
                            type="email"
                            name="email"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Email Address"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="field-error"
                          />
                        </div>
                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Password{" "}
                          </label>
                          <Field
                            type="password"
                            name="password"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Password"
                          />
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="field-error"
                          />
                        </div>
                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Enter Full Name{" "}
                          </label>
                          <Field
                            type="text"
                            name="fullName"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Full Name"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                "",
                              );
                              setFieldValue("fullName", e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="fullName"
                            component="div"
                            className="field-error"
                          />
                        </div>
                        <div className="flex flex-col w-full sm:w-[48%]">
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "rgba(25, 25, 25, 1)",
                            }}
                          >
                            Choose Designation
                          </span>
                          <div className="flex gap-4 mt-2 font-normal">
                            <div className="flex gap-2">
                              <Field
                                type="radio"
                                name="position"
                                value="Director"
                              />
                              Director
                            </div>
                            <div className="flex gap-2">
                              <Field
                                type="radio"
                                name="position"
                                value="Promoter"
                              />
                              Promoter
                            </div>
                            <div className="flex gap-2">
                              <Field
                                type="radio"
                                name="position"
                                value="Other"
                              />
                              Other
                            </div>
                          </div>
                          {values.position === "Other" && (
                            <>
                              <Field
                                name="otherPosition"
                                className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                                placeholder="Specify Other"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^A-Za-z\s]/g,
                                    "",
                                  );
                                  setFieldValue(
                                    "otherPosition",
                                    e.target.value,
                                  );
                                }}
                              />
                              <ErrorMessage
                                name="otherPosition"
                                component="div"
                                className="field-error"
                              />
                            </>
                          )}
                          {touched.position && errors.position && (
                            <span className="error text-[#ff0000]">
                              {errors.position}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-col w-full sm:w-[48%]">
                          <label className="mb-1 font-medium text-gray-700">
                            Enter Phone Number
                          </label>
                          <Field
                            type="text"
                            name="phone"
                            className="border border-solid border-[#D9D9D9] rounded-[8px] px-4 py-3 text-gray-900 focus:outline-none focus:ring-0 focus:border-green-600"
                            placeholder="Enter Phone Number"
                            maxLength={10}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                "",
                              );
                              setFieldValue("phone", e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="field-error"
                          />
                        </div>
                      </div>
                      <div className="flex justify-center w-full mt-8">
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="bg-green-700 text-white rounded-full px-6 py-2 hover:bg-green-800 transition-colors"
                        >
                          SAVE DETAILS
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion
          className="accordionbox rounded-[16px] w-full"
          sx={{ borderRadius: "16px" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{ padding: "0 16px" }}
          >
            <div className="flex flex-row justify-between w-full">
              <span className="font-semibold text-base text-[#1A1A1A]">
                Subscription Details
              </span>
            </div>
          </AccordionSummary>

          <AccordionDetails>
            <div className="flex justify-center cursor-pointer">
              <div className="grid grid-cols-2 w-[220px] text-sm font-semibold text-[#797979] rounded-full relative overflow-hidden border border-[#E4E4E4]">
                <div
                  className={`rounded-full py-2 px-4 z-10 text-center transition-all duration-500 ease-in-out ${
                    selectedDuration === "quarterly"
                      ? "text-white bg-[#017C57]"
                      : "bg-transparent"
                  }`}
                  onClick={() => setSelectedDuration("quarterly")}
                >
                  QUARTERLY
                </div>
                <div
                  className={`rounded-full py-2 px-4 z-10 text-center transition-all duration-500 ease-in-out ${
                    selectedDuration === "yearly"
                      ? "text-white bg-[#017C57]"
                      : "bg-transparent"
                  }`}
                  onClick={() => setSelectedDuration("yearly")}
                >
                  YEARLY
                </div>
              </div>
            </div>

            <div className="w-full max-w-[1500px] mt-8">
              <section className="slider-container max-w-full">
                <Slider {...settings}>
                  {filteredPlan?.map((plan, idx) => (
                    <div
                      key={idx}
                      className="block"
                      onClick={() => setSelectedPlan(plan)}
                    >
                      <SubscriptionCard
                        subscriptionPrice={plan.monthlyFees}
                        subscriptionType={plan.name}
                        planFeatures={plan.features}
                        isSelected={selectedPlan?.id === plan?.id}
                      />
                    </div>
                  ))}
                </Slider>
              </section>
            </div>

            {selectedPlan && (
              <div className="flex justify-center mt-10">
                <div
                  className="w-fit rounded-full uppercase text-white text-sm font-semibold bg-[#017C57] px-4 py-2 cursor-pointer"
                  onClick={() => {
                    // setShowSubscriptionForm(true);
                    handleSubscriptionMapping();
                  }}
                >
                  SAVE DETAILS
                </div>
              </div>
            )}

            {showSubscriptionForm && orderId && (
              <div className="fixed top-0 left-0 w-screen h-screen bg-[#F9F9F9B3] flex justify-center items-center z-30">
                <div className="relative w-[90%] max-w-[750px] bg-white rounded-[16px] p-5 border border-[#E4E4E4]">
                  <div
                    className="absolute top-[10px] right-[10px] cursor-pointer"
                    onClick={() => setShowSubscriptionForm(false)}
                  >
                    <img src={CrossIcon} alt="cross-icon" />
                  </div>

                  <div>
                    <div className="flex flex-wrap gap-y-4 mt-4">
                      <label
                        htmlFor="amountToPay"
                        className="w-full sm:w-[48%] md:w-[32%]"
                      >
                        <div className="font-semibold mb-2">Amount</div>
                        <input
                          name="amountToPay"
                          type="text"
                          value={`₹${amountToPay}`}
                          disabled
                          className="h-[40px] text-[18px] text-[#797979] rounded-[8px] pl-[12px] w-full border border-[#e4e4e4]"
                        />
                      </label>
                      <label
                        htmlFor="name"
                        className="w-full sm:w-[48%] md:w-[32%]"
                      >
                        <div className="font-semibold mb-2">Enter Name</div>
                        <input
                          name="name"
                          type="text"
                          className="h-[40px] text-[18px] text-[#797979] rounded-[8px] pl-[12px] w-full border border-[#e4e4e4]"
                          onChange={(e) =>
                            handlePaymentDetails("name", e.target.value)
                          }
                        />
                      </label>
                      <label
                        htmlFor="phone"
                        className="w-full sm:w-[48%] md:w-[32%]"
                      >
                        <div className="font-semibold mb-2">
                          Enter Phone Number
                        </div>
                        <input
                          name="phone"
                          type="text"
                          className="h-[40px] text-[18px] text-[#797979] rounded-[8px] pl-[12px] w-full border border-[#e4e4e4]"
                          onChange={(e) =>
                            handlePaymentDetails("phone", e.target.value)
                          }
                        />
                      </label>
                      <label
                        htmlFor="email"
                        className="w-full sm:w-[48%] md:w-[32%]"
                      >
                        <div className="font-semibold mb-2">Enter Email</div>
                        <input
                          name="email"
                          type="email"
                          className="h-[40px] text-[18px] text-[#797979] rounded-[8px] pl-[12px] w-full border border-[#e4e4e4]"
                          onChange={(e) =>
                            handlePaymentDetails("email", e.target.value)
                          }
                        />
                      </label>
                    </div>
                    {/* {paymentDetails.name &&
                      paymentDetails.phone &&
                      paymentDetails.email && (
                        <div className="flex justify-center mt-4">
                          <RazorpayPayment
                            amount={amountToPay}
                            orderId={orderId}
                            paymentDetails={paymentDetails}
                          />
                        </div>
                      )} */}
                  </div>
                </div>
              </div>
            )}
          </AccordionDetails>
        </Accordion>

        {/* <Accordion
          className="accordionbox"
          style={{
            borderRadius: "16px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
            sx={{
              padding: "0 16px",
            }}
          >
            <div style={{ width: "100%" }}>
              <div
                style={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                Credentials
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails>
            <Formik
              initialValues={{
                name: hospitalName,
                roleName: "hospital",
                phone: "",
                email: "",
                hospitalId: hospitalId,
                password: "",
                tmsVersion: "",
                fullName: "",
                position: "",
                otherPosition: "",
              }}
              validationSchema={hospitalCredentialsSchema}
              onSubmit={(values, { setSubmitting }) => {
                handleAddHospitalUser(values);
                setSubmitting(false);
              }}
              validateOnChange={true}
              validateOnBlur={false}
            >
              {({ isSubmitting, values, setFieldValue, touched, errors }) => (
                <Form>
                  <div className="case-form-container1">
                    <label htmlFor="email" className="label1">
                      <div className="text-content">Email</div>
                      <Field
                        type="email"
                        name="email"
                        className="input-field"
                        placeholder="Enter Email Address"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="field-error"
                      />
                    </label>

                    <label htmlFor="password" className="label1">
                      <div className="text-content">Password</div>
                      <Field
                        type="password"
                        name="password"
                        className="input-field"
                        placeholder="Enter Password"
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="field-error"
                      />
                    </label>
                  </div>
                  <div className="case-form-container1">
                    <label htmlFor="fullName" className="label1">
                      <div className="text-content">Enter Full Name</div>
                      <Field
                        type="text"
                        name="fullName"
                        className="input-field"
                        placeholder="Enter Full Name"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^A-Za-z\s]/g,
                            "",
                          );
                          setFieldValue("fullName", e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="fullName"
                        component="div"
                        className="field-error"
                      />
                    </label>

                    <div className="label1">
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "rgba(25, 25, 25, 1)",
                        }}
                      >
                        Choose Designation
                      </span>
                      <div className="flex gap-4 mt-2 font-normal">
                        <div className="flex gap-2">
                          <Field
                            type="radio"
                            name="position"
                            value="Director"
                          />
                          Director
                        </div>
                        <div className="flex gap-2">
                          <Field
                            type="radio"
                            name="position"
                            value="Promoter"
                          />
                          Promoter
                        </div>
                        <div className="flex gap-2">
                          <Field type="radio" name="position" value="Other" />
                          Other
                        </div>
                      </div>
                      {values.position === "Other" && (
                        <>
                          <Field
                            name="otherPosition"
                            className="input-field"
                            placeholder="Specify Other"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                "",
                              );
                              setFieldValue("otherPosition", e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="otherPosition"
                            component="div"
                            className="field-error"
                          />
                        </>
                      )}
                      {touched.position && errors.position && (
                        <span className="error text-[#ff0000]">
                          {errors.position}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="case-form-container1">
                    <label htmlFor="phone" className="label1">
                      <div className="text-content">Enter Phone Number</div>
                      <Field
                        type="text"
                        name="phone"
                        className="input-field"
                        placeholder="Enter Phone Number"
                        maxLength={10}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setFieldValue("phone", e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="field-error"
                      />
                    </label>
                  </div>

                  <div className="flex justify-center w-full mt-8">
                    <button
                      type="submit"
                      style={{
                        width: "125px",
                        height: "34px",
                        borderRadius: "32px",
                        padding: "8px 16px",
                        gap: "8px",
                        backgroundColor: "rgba(1, 124, 87, 1)",
                        color: "white",
                        border: "none",
                      }}
                    >
                      SAVE DETAILS
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </AccordionDetails>
        </Accordion> */}
        <div>
          <MapBoundaryDrawer
            onBoundaryChange={(coords) => setPolygon(coords)}
          />{" "}
        </div>
      </div>
    </div>
  );
};

export default AddHospital;
